import React from 'react';
import { MessageCircle } from 'lucide-react';
export function WhatsAppFab() {
  return <a href="https://wa.me/1234567890" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 group flex items-center" aria-label="Chat with us on WhatsApp" data-id="element-205">
      <div className="absolute right-full mr-4 bg-midnight-elevated text-beige text-sm px-4 py-2 rounded-full border border-white/10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none whitespace-nowrap shadow-xl" data-id="element-206">
        Chat with us
      </div>
      <div className="relative" data-id="element-207">
        <div className="absolute inset-0 bg-[#25D366] rounded-full blur-md opacity-50 group-hover:opacity-80 animate-pulse-glow transition-opacity" data-id="element-208"></div>
        <div className="relative w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center text-white shadow-lg transform group-hover:scale-110 transition-transform duration-300 border border-white/20" data-id="element-209">
          <MessageCircle className="w-7 h-7" data-id="element-210" />
        </div>
      </div>
    </a>;
}